import { render, staticRenderFns } from "./TabPanels.vue?vue&type=template&id=4a1b6425&"
import script from "./TabPanels.vue?vue&type=script&lang=js&"
export * from "./TabPanels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports